var _rect, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.42865,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D1E9FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2674_67223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.762 26.3333L23.4287 23M23.4287 23L20.0953 26.3333M23.4287 23V30.5M30.4203 28.325C31.2331 27.8819 31.8752 27.1807 32.2452 26.3322C32.6153 25.4836 32.6922 24.536 32.4638 23.6389C32.2355 22.7418 31.7149 21.9463 30.9842 21.3779C30.2536 20.8095 29.3544 20.5006 28.4287 20.5H27.3787C27.1264 19.5244 26.6563 18.6186 26.0036 17.8508C25.351 17.083 24.5327 16.4732 23.6104 16.0672C22.6881 15.6611 21.6858 15.4695 20.6788 15.5066C19.6717 15.5437 18.6862 15.8086 17.7963 16.2814C16.9064 16.7542 16.1353 17.4226 15.5409 18.2363C14.9465 19.0501 14.5443 19.9879 14.3645 20.9795C14.1847 21.971 14.2321 22.9904 14.503 23.9611C14.7739 24.9317 15.2614 25.8282 15.9287 26.5833",
    stroke: "#1570EF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.42865,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#EFF8FF",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2674_67223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13.4286 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconBlue);
export default __webpack_public_path__ + "static/media/upload-icon-blue.cd102e387d30cb133513e729574251bc.svg";
export { ForwardRef as ReactComponent };